import { Country } from '@dreryk/address-common-api';

import { createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { useCountries } from './CountriesSelectList.hooks';
import { countryKeyExtractor, countrySelectFilterCreator, getCountryDisplayValue } from './CountriesSelectList.utils';

export const CountriesSelectList = (): JSX.Element => {
   const countries = useCountries();
   return (
      <Select.Filter items={countries} filter={countrySelectFilterCreator}>
         {({ filteredItems }) => (
            <Select.List items={filteredItems} keyExtractor={countryKeyExtractor}>
               {(country) => (
                  <Select.Item<Country>
                     item={country}
                     testId={country.getIsoCode()}
                     label={<Select.Highlight node={createTranslatedText(getCountryDisplayValue(country))} />}
                  />
               )}
            </Select.List>
         )}
      </Select.Filter>
   );
};
